export const SOLE_TRADER_COMPANY_NUMBER = 'SoleTrader'

export const marketingUrl = `${import.meta.env.VITE_APP_URL}`.replace('app.', '')

export const privacyPolicyLink = `${marketingUrl}/privacy-policy`

export const termsAndConditionsLink = `${marketingUrl}/terms-conditions`

export const ukCreditCardProductId = '9b1d7081-273d-476c-a81e-79d92e3fd761'

export const iloProductId = '1c25a9bc-4cd0-4964-9f6e-1b12ac557c16'

// @TODO: Temporary (DMS-2158): the Instant Loan Funding subtype product on stage has no application form yet,
// so it routes to the standalone ILO form like the legacy ILO product until ILO v2 lands
export const stageInstantLoanFundingProductId = 'bfeb9379-0673-4180-bc21-85930ec8314e'

export const iloProductIds = [iloProductId, stageInstantLoanFundingProductId]

export const personalFundingProductId = '54b6c36a-0bae-4a75-ad5d-791ebe485935'

export const startupLoanProductId = 'ec82302b-37d8-43b8-b89c-f068fd6db47e'

export const startupLoanSubtype = 'StartupLoan'

export const startupLoanSubtypeId = 10

export const fundingReasons = {
  fundingOnboarding: 'fundingOnboarding',
  justBrowsing: 'justBrowsing',
  businessInsightsAndSavings: 'businessInsightsAndSavings'
}

export const journeyDestinations = {
  justBrowsing: { name: 'get-loan-offers', params: { fundingReason: fundingReasons.justBrowsing } },
  businessInsightsAndSavings: { name: 'get-loan-offers', params: { fundingReason: fundingReasons.businessInsightsAndSavings } },
  fundingOnboarding: { name: 'get-loan-offers', params: { fundingReason: fundingReasons.fundingOnboarding } }
}

export const fundingDetailsCardVariants = {
  complete: 'complete',
  prequalify: 'prequalify'
}

// backend document title/type pairs - must match the values used by requiredDocumentsAdapter in utils.js and ChooseDocumentType
export const fundingDocuments = {
  bankStatements: { title: '6 Months Company Bank Statements', type: 'Financials' },
  filedAccounts: { title: '1 Year Filed Accounts', type: 'Financials' }
}

export const maxDocumentFileSizeKb = 51200

export const revenueThresholdsByCountry = {
  Ireland: 0,
  'United Kingdom': 50000,
  'South Africa': 500000,
  Canada: 100000,
  'United States of America': 100000,
  Australia: 0
}

export const integrationStepVariants = {
  accountingAndBanking: 'accountingAndBanking',
  accountingOnly: 'accountingOnly'
}

export const integrationConnectedToast = {
  title: 'You have successfully linked your account',
  description: 'It may take up to 1 hour for integration to complete and for all your insights to appear.',
  severity: 'success',
  variant: 'container',
  icon: 'link'
}

export const tenantRedirectRoutes = {
  canada: {
    Loan: 'loan-matches',
    Grant: 'grant-matches',
    Equity: 'equity-matches'
  },
  aus: {
    Loan: 'loan-matches',
    Grant: 'grant-matches',
    Equity: 'equity-matches'
  },
  uk: {
    Loan: 'loan-matches',
    Grant: 'grant-matches',
    Equity: 'equity-matches'
  }
}

export const redirectRoutes = {
  canada: {
    Loan: 'loan-matches',
    Grant: 'grant-matches',
    Equity: 'equity-matches'
  },
  aus: {
    Loan: 'loan-matches',
    Grant: 'grant-matches',
    Equity: 'equity-matches'
  },
  uk: {
    Loan: 'dashboard',
    Grant: 'dashboard',
    Equity: 'dashboard'
  }
}

export const legacyDynamicForms = [
  {
    redirect: 'business-expansion',
    goalName: 'businessExpansion'
  },
  {
    redirect: 'start-business',
    goalName: 'startaBusiness'
  },
  {
    redirect: 'improve-cashflow',
    goalName: 'improveCashflow'
  },
  {
    redirect: 'purchase-stock',
    goalName: 'purchaseStock'
  },
  {
    redirect: 'grant',
    goalName: 'findGrant'
  },
  {
    redirect: 'asset-finance',
    goalName: 'softAssetFinance'
  },
  {
    redirect: 'property-finance',
    goalName: 'propertyFinance'
  },
  {
    redirect: 'research-development',
    goalName: 'researchDevelopment'
  },
  {
    redirect: 'equity',
    goalName: 'findInvestor'
  },
  {
    redirect: 'import-export-finance',
    goalName: 'importExportFinance'
  },
  {
    redirect: 'debt-refinance',
    goalName: 'debtRefinance'
  },
  {
    redirect: 'acquire-business',
    goalName: 'acquireABusiness'
  }
]

export const mfaRedirectToStorageKey = 'mfaRedirectTo'
export const mfaFlowNonceStorageKey = 'mfaFlowNonce'

export const routesWithoutWhitelabelGroupCheck = [
  'login',
  'mfa-callback',
  'sign-up',
  'sign-up-form-type',
  'forgot-password',
  'forgot-password-check-email',

  // natwest partner routes
  'natwest-landing',
  'natwest-form',
  'natwest-grants',
  'natwest-grants-overlay',
  'natwest-tax-savings-calculator'
]

// The default group id is the Swoop Group id
export const defaultGroupId = '77afb219-9221-4132-8667-36fe60ec23a3'
export const emptyGuid = '00000000-0000-0000-0000-000000000000'

export const defaultWhitelabelStyles = {
  group: {
    groupId: defaultGroupId,
    groupName: 'Swoop Funding'
  }
}

export const subdomainList = {
  tatcapital: ['tat'],
  bcc: [
    'bedfordshire-chamber-of-commerce',
    'black-country-chamber-of-commerce',
    'coventry-warwickshire-chamber-of-commerce',
    'devon-plymouth-chamber-of-commerce',
    'doncaster-chamber-of-commerce',
    'dundee-and-angus-chamber-of-commerce',
    'greater-manchester-chamber-of-commerce',
    'hampshire-chamber-of-commerce',
    'herefordshire-and-worcestershire-chamber-of-commerce',
    'hertfordshire-chamber-of-commerce-and-industry',
    'lincolnshire-chamber-of-commerce',
    'liverpool-chamber',
    'london-chamber-of-commerce-industry',
    'mid-yorkshire-chamber-of-commerce',
    'milton-keynes-chamber-of-commerce',
    'northamptonshire-chamber-of-commerce',
    'shropshire-chamber-of-commerce-enterprise',
    'staffordshire-chambers-of-commerce',
    'suffolk-chamber-of-commerce',
    'sussex-chamber-of-commerce',
    'west-cheshire-north-wales-chamber-of-commerce',
    'west-north-yorkshire-chamber-of-commerce',
    'cambridgeshire-chamber-of-commerce',
    'st-helens-chamber-of-commerce',
    'cumbria-chamber-of-commerce',
    'sheffield-chamber-of-commerce',
    'lancashire-chamber-of-commerce',
    'sommerset-chamber-of-commerce',
    'dorset-chamber'
  ],
  wfe: ['forentrepreneurs'],
  'umi-whitelabel': ['umi'],
  lcc: ['london-chamber-of-commerce-industry'],
  lloydsbank: ['new-lloyds-grant-finder-app']
}

export const webUrlRegExp =
  /^(?:(?:https?):\/\/)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,})))(?::\d{2,5})?(?:\/\S*)?$/

export const LSKeys = {
  prevBuildVersion: 'prevBuildVersion',
  truelayerIntegrationPrevRoute: 'truelayerIntegrationPrevRoute',
  bankIntegrationPrevRoute: 'bankIntegrationPrevRoute',
  bankIntegrationBankName: 'bankIntegrationBankName',
  productDetailsPrevRoute: 'productDetailsPrevRoute',
  apiDeckIntegrationPrevRoute: 'apiDeckIntegrationPrevRoute',
  plaidLinkToken: 'plaidLinkToken',
  plaidIntegrationPrevRoute: 'plaidIntegrationPrevRoute',
  plaidFlowMode: 'plaidFlowMode',
  plaidItemIdInFlight: 'plaidItemIdInFlight'
}

export const whiteListDocumentExtensions = 'jpg,jpeg,png,pdf,doc,docx,ppt,pptx,pps,ppsx,odt,xls,xlsx,txt'

export const swoopPartnerTypeCookieName = '_spt'
export const userWhitelabelGroupCookieName = '_stn'
export const gclidCookieName = '_gcl_aw'
export const swoopOpenBankingPartnerTypeValue = 'openbanking'

export const eligibleTermLoanRbsAppUrl = 'https://www.business.rbs.co.uk/business/loans-and-finance/small-business-loan.html'
export const eligibleTermLoanNatWestAppUrl = 'https://www.business.natwest.com/business/loans-and-finance/small-business-loan.html'
export const eligibleTermLoanUlsterBankAppUrl = 'https://digital.ulsterbank.co.uk/business/loans-and-finance/loan.html'
export const eligibleTermLoanHsbcAppUrl = 'https://www.business.hsbc.uk/en-gb/finance-and-borrowing/credit-and-lending/small-business-loan'
export const eligibleOverdraftsHsbcAppUrl = 'https://www.business.hsbc.uk/en-gb/finance-and-borrowing/credit-and-lending/business-overdraft?DCSext.nav=foot-mat'
export const dealOsEquityRaiseUrl = 'https://dealos.info/swoop'

export const fundingProcessDetails = [
  {
    title: 'Register your interest',
    description: 'After considering your matches, you can request products that you are interested in',
    status: 'InformationRequested'
  },
  {
    title: 'Share documents',
    description: 'Share to support your funding process, you will need to share relevant documentation so that your funding manager can service your request.',
    status: 'ReviewingYourDetails'
  },
  {
    title: 'Discuss your funding options',
    description: 'Your funding manager will be in touch to discuss your funding options, including any products you requested',
    status: ''
  },
  {
    title: 'Apply for funding',
    description: 'With your permission, your funding manager will discuss your case with relevant lenders to gauge interest.',
    status: ''
  },
  {
    title: 'Review offer',
    description:
      'If there is interest in your case, you and your funding manager will discuss the offer(s) you’ve received back from the funder(s) and what are your possible next steps.',
    status: ''
  },
  {
    title: 'Accept the offer and get funded',
    description: 'When you’re happy with the offer(s), we’ll help co- ordinate getting the cash into your account',
    status: ''
  }
]

export const documentTypes = [
  {
    label: 'Financials',
    value: 'Financials'
  },
  {
    label: 'Ownership',
    value: 'Ownership'
  },
  {
    label: 'Applications',
    value: 'Applications'
  },
  {
    label: 'Funding Documents',
    value: 'FundingDocuments'
  },
  {
    value: 'Identification',
    label: 'Identification'
  },
  {
    value: 'Other',
    label: 'Other'
  }
]

export const documentTypesDic = documentTypes.reduce((acc, docType) => ({ ...acc, [docType.value]: docType.label }), {})

export const loanTermMaxDic = {
  0: 'N/A',
  1: '1 month',
  2: '2 months',
  3: '3 months',
  6: '6 months',
  12: '1 year',
  24: '2 years',
  60: '5 years'
}

export const titleOptions = [
  { label: 'Brigadier', value: 'Brigadier' },
  { label: 'Sir', value: 'Sir' },
  { label: 'Dame', value: 'Dame' },
  { label: 'Father', value: 'Father' },
  { label: 'Honourable', value: 'Honourable' },
  { label: 'Lady', value: 'Lady' },
  { label: 'Lord', value: 'Lord' },
  { label: 'Major', value: 'Major' },
  { label: 'Miss', value: 'Miss' },
  { label: 'Mr', value: 'Mr' },
  { label: 'Mrs', value: 'Mrs' },
  { label: 'Ms', value: 'Ms' },
  { label: 'Professor', value: 'Professor' },
  { label: 'Reverend', value: 'Reverend' },
  { label: 'Sergent', value: 'Sergent' },
  { label: 'Commander', value: 'Commander' }
]

export const fundingTypes = [
  { label: 'Loans', value: 'Loans' },
  { label: 'Equity', value: 'Equity' },
  { label: 'Grants', value: 'Grants' }
]

export const genderOptions = [
  { label: 'Female', value: 'Female' },
  { label: 'Male', value: 'Male' },
  { label: 'Prefer not to say', value: 'Prefer not to say' },
  { label: 'Other', value: 'Other' }
]

export const productTypeOptions = [
  { label: 'Loan', value: 'Loan' },
  { label: 'Equity', value: 'Equity' },
  { label: 'Grant', value: 'Grant' }
]

export const productTypeOptionsDic = productTypeOptions.reduce((acc, productTypeOption) => {
  acc[productTypeOption.value] = productTypeOption
  return acc
}, {})

export const loanSubCategoryTypeOptions = [
  { label: 'Invoice Finance', value: 'InvoiceFinance' },
  { label: 'Supplier Finance', value: 'SupplierFinance' },
  { label: 'Order Finance', value: 'OrderFinance' },
  { label: 'Asset Finance & Leasing', value: 'AssetFinanceLeasing' },
  { label: 'Term Loan', value: 'TermLoan' },
  { label: 'Working Capital Loan', value: 'WorkingCapitalLoan' },
  { label: 'Merchant Finance', value: 'MerchantFinance' },
  { label: 'Crowdfunding', value: 'CrowdfundingLoan' },
  { label: 'MBO Finance', value: 'MboFinance' },
  { label: 'Overdrafts', value: 'Overdrafts' },
  { label: 'Commercial Mortgage', value: 'CommercialMortgage' },
  { label: 'Credit Cards', value: 'CreditCards' },
  { label: 'Startup Loan', value: 'StartupLoan' },
  { label: 'RD Tax Loan', value: 'RAndDTaxLoan' },
  { label: 'Commercial Mortgage Investment', value: 'CommercialMortgageInvestment' },
  { label: 'Commercial Mortgage Owner Occupier', value: 'CommercialMortgageOwnerOccupier' },
  { label: 'Development Finance', value: 'DevelopmentFinance' },
  { label: 'Buy to Let', value: 'BuyToLet' },
  { label: 'Bridging Loan', value: 'BridgingLoan' },
  { value: 'LineOfCredit', label: 'Line Of Credit' },
  { value: 'AcquisitionFinancing', label: 'Acquisition Financing' },
  { value: 'SoftwareFinancing', label: 'Software Financing' },
  { value: 'AssetBasedLending', label: 'Asset-Based Lending' },
  { label: 'Other', value: 'Other' }
]

export const equitySubCategoryTypeOptions = [
  { label: 'SEIS', value: 'SEIS' },
  { label: 'EIS', value: 'EIS' },
  { label: 'VCT', value: 'VCT' },
  { label: 'VC', value: 'VC' },
  { label: 'Angel', value: 'Angel' },
  { label: 'Private Equity', value: 'PrivateEquity' },
  { label: 'Family Office', value: 'FamilyOffice' },
  { label: 'Crowdfunding', value: 'CrowdfundingEquity' }
]

export const tradingAgeRangesOptions = [
  { label: '0 - 6 months', value: 1 },
  { label: '6 months - 1 year', value: 7 },
  { label: '1 year - 2 years', value: 13 },
  { label: '2 years - 5 years', value: 25 },
  { label: '5 years - 7 years', value: 61 },
  { label: '7 years - 10 years', value: 85 },
  { label: '10 years +', value: 121 }
]

export const tradingAgeRangesDic = tradingAgeRangesOptions.reduce((acc, { label, value }) => ({ ...acc, [value]: label }), {})

export const fundingPurposesOptions = [
  { label: 'Covid-19 Impact', value: 'Covid-19 Impact' },
  { label: 'Business expansion', value: 'Business expansion' },
  { label: 'Start a business', value: 'Start a business' },
  { label: 'Acquire a business', value: 'Acquire a business' },
  { label: 'Research', value: 'Research' },
  { label: 'Product development', value: 'Product development' },
  { label: 'Import/Export finance', value: 'Import/Export finance' },
  { label: 'Purchase stock', value: 'Purchase stock' },
  { label: 'Improve cashflow', value: 'Improve cashflow' },
  { label: 'Purchase or develop a property', value: 'Purchase or develop a property' },
  { label: 'Debt refinance ', value: 'Debt refinance ' },
  { label: 'Purchase or refinance of an asset', value: 'Purchase or refinance of an asset' }
]

export const productSubCategoryTypeOptions = [...equitySubCategoryTypeOptions, ...loanSubCategoryTypeOptions]

export const productSubCategoryTypeOptionsDic = productSubCategoryTypeOptions.reduce((acc, productSubCategoryTypeOption) => {
  acc[productSubCategoryTypeOption.value] = productSubCategoryTypeOption
  return acc
}, {})

export const interestedCategoryNamesOptions = [
  { label: 'Banking', value: 'Banking' },
  { label: 'Utilities', value: 'Utilities' },
  { label: 'Broadband', value: 'Broadband' },
  { label: 'FX', value: 'FX' },
  { label: 'Phone', value: 'Phone' }
]

export const fundingRepaymentPeriodYearsOptions = [
  { label: '0 year', value: 0 },
  { label: '1 year', value: 1 },
  { label: '2 years', value: 2 },
  { label: '3 years', value: 3 },
  { label: '4 years', value: 4 },
  { label: '5 years', value: 5 },
  { label: '6 years', value: 6 },
  { label: '7 years', value: 7 },
  { label: '8 years', value: 8 },
  { label: '9 years', value: 9 },
  { label: '10 years', value: 10 }
]
export const fundingRepaymentPeriodMonthOptions = [
  { label: '0 months', value: 0 },
  { label: '1 month', value: 1 },
  { label: '2 months', value: 2 },
  { label: '3 months', value: 3 },
  { label: '4 months', value: 4 },
  { label: '5 months', value: 5 },
  { label: '6 months', value: 6 },
  { label: '7 months', value: 7 },
  { label: '8 months', value: 8 },
  { label: '9 months', value: 9 },
  { label: '10 months', value: 10 },
  { label: '11 months', value: 11 }
]

export const opportunitySpeedDic = {
  1: '< 1 day',
  2: '< 2 days',
  3: '< 3 days',
  4: '< 4 days',
  5: '< 5 days',
  6: '< 6 days',
  7: '< 1 week',
  8: '1 week - 1 month',
  9: '1 month - 3 months',
  10: '3 months - 6 months',
  11: '6 months+'
}

export const productsAndGoalsDeepLinks = {
  'aggregator-loan': [{ name: 'aggregator-form' }],
  'credit-score': [{ name: 'credit-health-check' }],
  'loan-matches': [{ name: 'loan-matches' }],
  'loans-matches': [{ name: 'loan-matches' }],
  integrations: [{ name: 'integrations' }],
  'cashflow-forecast-integration': [{ name: 'cashflow-forecasting-integration' }],
  // These deepLinks should not be used with the back entrance
  loans: [{ name: 'loan-matches' }],
  equity: [{ name: 'equity-matches' }],
  grants: [{ name: 'grant-matches' }],
  'grants-form': [{ name: 'get-started', query: { fundingReason: 'findGrant' } }],
  'property-finance': [{ name: 'get-started', query: { fundingReason: 'propertyFinance' } }]
}

export const fundingRequiredInsightId = '83d34923-7bda-4c78-9784-fe072432cb60'
export const decisionTimeInsightId = '9659b104-d0f9-41a7-a224-b78c125adf8c'

export const utmTrackingCookies = [
  'utm_source',
  'utm_medium',
  'utm_campaign',
  'utm_term',
  'utm_content',
  'http_referer',
  'last_page_visited',
  'first_page_visited',
  'gclid',
  'current_url'
]

export const navMenuTypes = {
  SIGNIN: 'signin',
  CONTACT: 'contact',
  MAIN: 'main'
}

export const TITLES = {
  FUNDING_REASON_FORM_ONE: 'What brings you to Swoop today?',
  FUNDING_REASON_FORM_SECURE_FUNDS: 'What will the funds primarily be used for?',
  FUNDING_REASON_FORM_NOT_SURE: 'Please select the most relevant option below'
}

export const stateOptionsByCountry = {
  US: [
    { value: 'AL', label: 'Alabama' },
    { value: 'AK', label: 'Alaska' },
    { value: 'AZ', label: 'Arizona' },
    { value: 'AR', label: 'Arkansas' },
    { value: 'CA', label: 'California' },
    { value: 'CO', label: 'Colorado' },
    { value: 'CT', label: 'Connecticut' },
    { value: 'DE', label: 'Delaware' },
    { value: 'FL', label: 'Florida' },
    { value: 'GA', label: 'Georgia' },
    { value: 'HI', label: 'Hawaii' },
    { value: 'ID', label: 'Idaho' },
    { value: 'IL', label: 'Illinois' },
    { value: 'IN', label: 'Indiana' },
    { value: 'IA', label: 'Iowa' },
    { value: 'KS', label: 'Kansas' },
    { value: 'KY', label: 'Kentucky' },
    { value: 'LA', label: 'Louisiana' },
    { value: 'ME', label: 'Maine' },
    { value: 'MD', label: 'Maryland' },
    { value: 'MA', label: 'Massachusetts' },
    { value: 'MI', label: 'Michigan' },
    { value: 'MN', label: 'Minnesota' },
    { value: 'MS', label: 'Mississippi' },
    { value: 'MO', label: 'Missouri' },
    { value: 'MT', label: 'Montana' },
    { value: 'NE', label: 'Nebraska' },
    { value: 'NV', label: 'Nevada' },
    { value: 'NH', label: 'New Hampshire' },
    { value: 'NJ', label: 'New Jersey' },
    { value: 'NM', label: 'New Mexico' },
    { value: 'NY', label: 'New York' },
    { value: 'NC', label: 'North Carolina' },
    { value: 'ND', label: 'North Dakota' },
    { value: 'OH', label: 'Ohio' },
    { value: 'OK', label: 'Oklahoma' },
    { value: 'OR', label: 'Oregon' },
    { value: 'PA', label: 'Pennsylvania' },
    { value: 'RI', label: 'Rhode Island' },
    { value: 'SC', label: 'South Carolina' },
    { value: 'SD', label: 'South Dakota' },
    { value: 'TN', label: 'Tennessee' },
    { value: 'TX', label: 'Texas' },
    { value: 'UT', label: 'Utah' },
    { value: 'VT', label: 'Vermont' },
    { value: 'VA', label: 'Virginia' },
    { value: 'WA', label: 'Washington' },
    { value: 'WV', label: 'West Virginia' },
    { value: 'WI', label: 'Wisconsin' },
    { value: 'WY', label: 'Wyoming' }
  ],
  CA: [
    { value: 'AB', label: 'Alberta' },
    { value: 'BC', label: 'British Columbia' },
    { value: 'MB', label: 'Manitoba' },
    { value: 'NB', label: 'New Brunswick' },
    { value: 'NL', label: 'Newfoundland and Labrador' },
    { value: 'NS', label: 'Nova Scotia' },
    { value: 'ON', label: 'Ontario' },
    { value: 'PE', label: 'Prince Edward Island' },
    { value: 'QC', label: 'Quebec' },
    { value: 'SK', label: 'Saskatchewan' },
    { value: 'NT', label: 'Northwest Territories' },
    { value: 'NU', label: 'Nunavut' },
    { value: 'YT', label: 'Yukon' }
  ],
  UK: [
    { value: 'ENG', label: 'England' },
    { value: 'SCT', label: 'Scotland' },
    { value: 'WLS', label: 'Wales' },
    { value: 'NIR', label: 'Northern Ireland' }
  ],
  AU: [
    { value: 'NSW', label: 'New South Wales' },
    { value: 'VIC', label: 'Victoria' },
    { value: 'QLD', label: 'Queensland' },
    { value: 'WA', label: 'Western Australia' },
    { value: 'SA', label: 'South Australia' },
    { value: 'TAS', label: 'Tasmania' },
    { value: 'ACT', label: 'Australian Capital Territory' },
    { value: 'NT', label: 'Northern Territory' }
  ]
}
